<template>
    <div class="TutorialDialogue">
        <div class="td-container">
            
            <div class="td-close" @click="myToggleTutorialDialogue()"/>

            <div id="mySwiper" class="swiper mp-gallery">
                <div class="swiper-wrapper">

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/flux360-Tutorial_scroll.svg" alt="">
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-title">Die EVONIK VR-Tour entdecken</div>
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-text">Ziehen Sie nach links/rechts, um die Umgebung zu erkunden.</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-title">Experience the  EVONIK VR-Tour</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-text">Please pull left/right to discover the environment.</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/SprungpunktIcon_bw.png" alt="">
                            <div  v-if="this.chosenLanguage=='de'" class="td-slide-title">Sprungpunkte</div>
                            <div  v-if="this.chosenLanguage=='de'" class="td-slide-text">Durch Klicken auf dieses Icon gelangen Sie in den nächsten Berreich bzw in die nächste Situation.</div>
                            <div  v-if="this.chosenLanguage=='en'" class="td-slide-title">Transition points</div>
                            <div  v-if="this.chosenLanguage=='en'" class="td-slide-text">By clicking this icon, you will get to the next area and situation.</div>
                        </div>
                    </div>
<
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Map.svg" alt="">
                            <div  v-if="this.chosenLanguage=='de'" class="td-slide-title">Zur Übersicht</div>
                            <div  v-if="this.chosenLanguage=='de'" class="td-slide-text">Durch Klicken auf dieses Icon gelangen Sie zurück zur Übersicht aller Sprungpunkte.</div>
                            <div  v-if="this.chosenLanguage=='en'" class="td-slide-title">Overview</div>
                            <div  v-if="this.chosenLanguage=='en'" class="td-slide-text">By clicking this icon an overview of all transition points will be displayed.</div>
                        </div>
                    </div>

                    
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Fullscreen.svg" alt="">
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-title">Vollbildmodus</div>
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-text">Durch Klicken auf dieses Icon wird der gesamte Showroom im Vollbildmodus dargestellt.</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-title">Fullscreen mode</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-text">By clicking this icon the showroom will be displayed in fullscreen mode.</div>
                        </div>
                    </div>
<!--
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Tutorial.svg" alt="">
                            <div class="td-slide-title">Hilfe</div>
                            <div class="td-slide-text">Durch Klicken auf dieses Icon erhalten Sie erneut diese Hilfestellung aller Funktion.</div>
                        </div>
                    </div>


                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Communication.svg" alt="">
                            <div class="td-slide-title">Kommunikation</div>
                            <div class="td-slide-text">Durch Klicken auf dieses Icon kann das Video und Audio Kommunkationsfenster geöffnet und verborgen werden.</div>
                        </div>
                    </div>
-->
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/info.png" alt="">
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-title">Informations-Icons</div>
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-text">Durch Klicken auf dieses Icon eröffnen sich Ihnen tolle Zusatzinformationen in verschiedenen Formaten (z. B. PDF, Foto, Links oder Videos).</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-title">Information-Buttons</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-text">By clicking this icon additional information will be displayed (e.g. PDFs, fotos, links oder videos).</div>
                        </div>
                    </div>

                    <div class="swiper-slide" v-show="isGyrosSupported">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/gyrosicon.png" alt="">
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-title">Gyroskop</div>
                            <div v-if="this.chosenLanguage=='de'" class="td-slide-text">Durch Klicken dieses Icons werden die Drehbewegungen ihres Geräts auf den Blickausschnitt übertragen. Dadurch kann das Gerät als eine Art Fenster in die Situation genutzt werden.</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-title">Gyroscope</div>
                            <div v-if="this.chosenLanguage=='en'" class="td-slide-text">By clicking this icon your view rotates with your mobile device and you can use your tablet as a kind of window to the situation.</div>
                        </div>
                    </div>

<!--
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/flux360-360-viewer-Button.svg" alt="">
                            <div class="td-slide-title">360° View-Buttons</div>
                            <div class="td-slide-text">Durch klicken auf dieses Icon eröffnet sich Ihnen ein 360° Viewer, welcher Ihnen eine Rundumsicht auf ein ausgewähltes Objekt bietet.</div>
                        </div>
                    </div>
-->
                </div>
            </div>

            <div class="td-navigation">
                <div class="td-navigation-container">
                    <div id="swiper-pagination"/>
                    <div class="td-confirm">
                        <div class="td-confirm-button" @click="myToggleTutorialDialogue()">
                            <div v-if="this.chosenLanguage=='de'" >Verstanden</div>
                            <div v-if="this.chosenLanguage=='en'">Okay</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>  
    </div>  
</template>

<style>
.TutorialDialogue{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0px;
    background: rgba(0, 0, 0, 0.4);
}
.td-container{
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    width: 35%;
    height: 40%;
    min-width: 400px;
    min-height: 350px;
    overflow: hidden;
    border-radius: 2px;
    top: 50px;
}
.swiper{
    height: 100%;
    width: 100%;
}
.swiper-slide{
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.td-slide{
    height: 60%;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 10%;
}
.td-slide-icon{
    width: 30%;
    height: 30%;
    margin-bottom: 30px;
}
.td-slide-title{
    text-align: left;
    width: 100%;
    font-weight: bolder;
    font-size: 20px;
    margin-bottom: 5px;
}
.td-slide-text{
    text-align: left;
    align-self: flex-start;
    width: 100%;
    font-size: 16px;
}
.td-navigation{
    position: absolute;
    z-index: 2;
    bottom: 0;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
}
.td-navigation-container{
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
#swiper-pagination{
    width: 50%;
}
.TutorialDialogue .swiper-pagination-bullet{
    width: 16px !important;
    height: 16px !important;
    background: transparent;
    border: 2px solid white;
    opacity: 1;
    transition: background .2s ease, border .2s ease;
}
.TutorialDialogue .swiper-pagination-bullet:first-child{
    margin-left: 0 !important;
}
.TutorialDialogue .swiper-pagination-bullet-active{
    background: white;
}
.td-confirm{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}
.td-confirm-button{
    padding: 5px 20px;
    border: 2px solid white;
    color: white;
    font-size: 14px;
    cursor: pointer;
    border-radius: 5px;
    transition: background .2s ease, color .2s ease;
}
.td-confirm-button:hover{
    background: white;
    color: black;
}

.td-close{
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid white;
    cursor: pointer;
    z-index: 2;
    background: transparent;
    transition: background .2s ease;
}
.td-close:before, .td-close:after{
    position: absolute;
    top: 5px;
    left: 16px;
    content: ' ';
    height: 25px;
    width: 3px;
    background-color: white;
    transition: background .2s ease;
}
.td-close:before{
    transform: rotate(45deg);
}
.td-close:after{
    transform: rotate(-45deg);
}
.td-close:hover{
    background: white;
}
.td-close:hover:after, .td-close:hover::before{
    background: black;
}
</style>
    
<script>
import Swiper , { Pagination } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import { mapGetters, mapMutations } from "vuex";
import Fullscreen from 'vue-fullscreen/src/component.vue';

export default {
    inject: ["toggleTutorialDialogue"],
    data: function () {
        return {
            tutorialDialogueVisible: false,
            currentSwiperIndex: 0,
            firstTime: true
        }
    }, 
    computed: {
    ...mapGetters([
      "chosenLanguage",
      "currentSituation",
      "isDialogueOpen",
      "isGyrosSupported"
    ]),
  },
    mounted(){
        setTimeout(() => {
            this.swiper = new Swiper('#mySwiper',{
                modules: [Pagination],
                spaceBetween: 50,
                direction: 'horizontal',
                clickable: true,
                mousewheel: true,
                observer: true,
                pagination: {
                    el: '#swiper-pagination',
                    clickable: true,
                },
            });
            this.swiper.on('slideChange', () => {
                this.currentSwiperIndex = this.swiper.activeIndex;
            });
        }, 0); 
       
    }, 
    methods: {
        ...mapMutations([
        "updateRuntimeState"
    ]),
        myToggleTutorialDialogue(){
            let self = this;
            if(this.firstTime==true){
                this.firstTime= false;
                self.$store.commit("updateRuntimeState",{"id":this.currentSituation.id, "waitingForResume":true})
            }
            this.toggleTutorialDialogue();
        }
    },
}

</script>